// Pile de notifications en haut de l'écran, sous la safe area. Toucher une notification la ferme.
// L'expiration (4,5 s) et le plafond de notifications sont gérés par le store (pushToast).
import { dismissToast, useAppState } from "../store";
import type { Toast } from "../store";
import "./Toasts.css";

const GLYPH: Record<Toast["tone"], string> = { info: "✦", succes: "✓", danger: "!" };

export function Toasts() {
  const { toasts } = useAppState();
  if (toasts.length === 0) return null;
  return (
    <div class="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          class={`toasts-item toasts-item--${t.tone}`}
          onClick={() => dismissToast(t.id)}
        >
          <span class="toasts-mark" aria-hidden="true">{GLYPH[t.tone]}</span>
          <span class="toasts-text">{t.text}</span>
          <span class="toasts-close" aria-hidden="true">×</span>
        </button>
      ))}
    </div>
  );
}
